import { combineReducers } from "redux";
import { collections } from "./shared/collections";
import items from "./shared/items";
import NegativeKeywordConstants from "../constants/NegativeKeywords";

export default combineReducers({
    collections: collections(NegativeKeywordConstants.ACTION_TYPE_IDENTIFIER),
    items: items(NegativeKeywordConstants.ACTION_TYPE_IDENTIFIER)
});
